import Promise from 'promise-polyfill'

const helpers = {
  refresh (context, payload, options) {
    const vue = payload.vueinstance
    return new Promise((resolve, reject) => {
      let params = options.hasOwnProperty('params') ? options.params : {}
      vue.$backend[options.backend][options.method](params)
        .then(res => {
          context.commit(options.mutation, res.body)
          resolve(context.state[options.state])
        }).catch(err => {
          reject(err)
        })
    })
  },
  list (context, payload, options) {
    if (context.state[options.state] === null) {
      return context.dispatch(options.action, payload)
    } else {
      return new Promise((resolve, reject) => {
        resolve(context.state[options.state])
      })
    }
  }
}

export default helpers



// WEBPACK FOOTER //
// ./src/store/helpers.js